export const ERRORS = {
  API_INTERACTION: 'API Interaction Error',
  APPLICATION_CRASHED: 'Application Crashed',
  UNKNOWN: 'Unknown UI Error',
  AUTH_LOGIN_SUCCESS_HANDLER: 'authLoginSuccessHandler Error',
  PROCESS_EMAIL_QUERY: 'processEmailQueryHandler Error',
  PROCESS_REPORTS_QUERY: 'processReportsHandler Error',
  ONE_SIGNAL_INITIALIZATION: 'OneSignal initialization error',
  ASYNC_ROUTER: 'Async router error',
}
